module.exports = __webpack_public_path__ + "img/Blocked-PNG-Image.2b7d490a.png";